import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { iAxios } from '../../../lib/utils';
import { useProjectNames } from '../../../lib/hooks';
import { DATA_COLORS, chartTooltip } from '../../../lib/chartTheme';
import Icon from '../../ds/Icon';

const ProductBacklog = ({ ASSIGNMENTS = {} }) => {
    const [projectStatus, setProjectStatus] = useState([]);
    const [sortMode, setSortMode] = useState('issues');
    const projectNames = useProjectNames();

    useEffect(() => {
        iAxios.get(`/api/v1/tickets/open-status`).then((resp) => {
            const chartData = resp.data.data.filter(p => p.open).map((p) => ({
                name: p.name,
                value: parseInt(`${p.open ? p.open : 0}`)
                    + parseInt(`${p.testing ? p.testing : 0}`)
                    + parseInt(`${p.working ? p.working : 0}`)
            }));
            chartData.sort((a, b) => b.value - a.value);
            setProjectStatus(chartData);
        }).catch((error) => {
            console.error('Error : ', error);
        });
    }, [1]);

    let total = 0;
    // Resolve the GitLab project path to a human-readable name; keep the path as
    // `id` for the poker link.
    const withNames = projectStatus.map(p => ({ id: p.name, name: projectNames[p.name] || p.name, value: p.value, url: p.url }));
    const sorted = [...withNames].sort((a, b) => sortMode === 'name'
        ? a.name.localeCompare(b.name)
        : b.value - a.value);
    const pieData = withNames.filter(item => item.value > 0);

    return (
        <div className="ds-panel">
            <div className="ds-panel__head">
                <h3 className="ds-panel__title">Product Backlog</h3>
                <label className="ds-sort">
                    <Icon name="sort" className="ds-sort__icon" title="Sort projects" />
                    <select className="ds-select ds-sort__select" value={sortMode} onChange={e => setSortMode(e.target.value)} aria-label="Sort projects by">
                        <option value="issues">Issues</option>
                        <option value="name">Project name</option>
                    </select>
                </label>
            </div>

            <div className="dash-chart">
                <ResponsiveContainer width="100%" aspect={1.3}>
                    <PieChart margin={{ top: 12, right: 12, left: 12, bottom: 12 }}>
                        <Pie
                            isAnimationActive={false}
                            data={pieData}
                            dataKey="value"
                            nameKey="name"
                            innerRadius="48%"
                            outerRadius="74%"
                            paddingAngle={2}
                            cx="50%"
                            cy="50%"
                            stroke="var(--ds-surface)"
                            strokeWidth={2}
                            label>
                            {pieData.map((entry, index) => (
                                <Cell
                                    key={entry.id}
                                    fill={ASSIGNMENTS[entry.id] || DATA_COLORS[index % DATA_COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip {...chartTooltip} />
                    </PieChart>
                </ResponsiveContainer>
            </div>

            <div className="ds-table-wrap">
                <table className="ds-table is-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Project</th>
                            <th>Issues</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sorted.map((row, idx) => {
                            total += parseInt(`${row.value}`);
                            return (
                                <tr key={`row_${idx}`}>
                                    <td className="ds-nums">{idx + 1}</td>
                                    <td><Link to={`/project/${row.id}`}>{row.name}</Link></td>
                                    <td className="ds-nums">{row.url ? <a href={row.url}>{row.value}</a> : row.value}</td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td></td>
                            <td><strong>Total</strong></td>
                            <td className="ds-nums"><strong>{total}</strong></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ProductBacklog;
